import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4410dbde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buttons-outer" }
const _hoisted_2 = { class: "button-outer button-cancel" }
const _hoisted_3 = {
  key: 0,
  class: "button-outer button-back"
}
const _hoisted_4 = {
  key: 1,
  class: "button-outer button-next"
}
const _hoisted_5 = {
  key: 2,
  class: "button-outer button-finish"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ion_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.triggerFormSubmit(_ctx.HOST_URL, 'cancel'))),
        expand: "block",
        size: "large",
        color: "medium",
        fill: "outline",
        class: "app-navigation-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data && _ctx.data.cancellabel ? _ctx.data.cancellabel : "Abbrechen"), 1)
        ]),
        _: 1
      })
    ]),
    (_ctx.hasButton('back'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_ion_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.triggerFormSubmit(_ctx.data.back, 'back'))),
            expand: "block",
            size: "large",
            class: "app-navigation-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.backlabel), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasButton('next'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_ion_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.triggerFormSubmit(_ctx.data.next, 'next'))),
            expand: "block",
            size: "large",
            class: "app-navigation-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.nextlabel), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasButton('finish'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_ion_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.triggerFormSubmit(_ctx.data.finish, 'finish'))),
            expand: "block",
            size: "large",
            color: "success",
            class: "app-navigation-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.finishlabel), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}